<style>
div.vs-popup {
  width: 800px !important;
}
</style>

<template>
  <div class="content-wrapper">
    <vs-row class="my-4">
      <vs-col vs-lg="7" vs-sm="7">
        <div class="my-4">
          <label>Check-in Report</label>
          <vs-select v-model="selectedReport" @change="reportChangeHandler()">
            <vs-select-item
              :key="index"
              :value="option.value"
              :text="option.label"
              v-for="(option, index) in reportOptions"
            />
          </vs-select>
        </div>
      </vs-col>
      <vs-col
        vs-align="flex-end"
        vs-lg="5"
        vs-sm="5"
        class="m-0 p-0 flex justify-end items-end"
      >
        <ul class="demo-alignment pb-0" style="float: right">
          <li class="pl-4 border-0 border-solid border-grey">
            <i
              class="fas fa-file-download fa-2x cursor-pointer hover:text-primary"
              @click="exportHandler()"
            ></i>
          </li>
        </ul>
      </vs-col>
    </vs-row>
    <vx-card>
      <b-table
        ref="table"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="false"
        :busy.sync="isBusy"
        :items="checkinReportGroup"
        :fields="columns"
        :per-page="perPage"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(name)="data">
          <strong>{{ data.item.name }}</strong>
        </template>

        <template v-slot:cell(action)="data">
          <vs-button
            @click="viewLogHandler(data.item)"
            color="primary"
            type="flat"
          >
            View log
          </vs-button>
        </template>
      </b-table>
      <div class="mt-3 text-right">
        <vs-pagination
          :total="Math.ceil(totalRows / perPage)"
          :max="7"
          v-show="totalRows > perPage"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        />
        <div class="mt-3">
          {{ from | numFormat("0,0") }} to {{ to | numFormat("0,0") }} of
          {{ totalRows | numFormat("0,0") }} orders
        </div>
      </div>
    </vx-card>

    <vs-popup title="Check-in Log" :active.sync="checkinLogPopup">
      <div class="m-5">
        <b-table
          ref="logTable"
          striped
          hover
          fixed
          responsive
          show-empty
          sort-icon-left
          :selectable="false"
          :select-mode="`multi`"
          :items="checkinLog"
          :fields="logColumns"
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2" style="height: 600px">
              <b-spinner class="align-middle"></b-spinner>
              <div class="mt-3">
                <strong>Loading...</strong>
              </div>
            </div>
          </template>
        </b-table>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import Service from "@/services";
import XLSX from "xlsx";

export default {
  data: () => ({
    event: null,
    checkinReportGroup: [],
    checkinLog: [],
    selectedReport: "all",
    reportOptions: [{ type: "pre", label: "All Days", value: "all" }],
    columns: [
      { label: "Name", key: "name", sortable: false },
      { label: "Ticket", key: "ticket", sortable: false },
      { label: "Role", key: "role", sortable: false },
      { label: "Type", key: "type", sortable: false },
      { label: "Count", key: "count", sortable: false },
      { label: "At", key: "at" },
      { label: "", key: "action", sortable: false },
    ],
    logColumns: [
      { label: "Name", key: "name", sortable: false },
      { label: "Ticket", key: "ticket", sortable: false },
      { label: "RFID Tag", key: "rfid", sortable: false },
      { label: "Role", key: "role", sortable: false },
      { label: "Type", key: "type", sortable: false },
      { label: "Day", key: "day", sortable: false },
      { label: "At", key: "at" },
      { label: "With", key: "checkin_with", sortable: false },
    ],
    checkinLogPopup: false,
    from: 1,
    to: 1,
    isBusy: false,
    currentPage: 1,
    perPage: 20,
    totalRows: 0,
    pageOptions: [2, 5, 10, 15, 30, 50],
  }),
  async created() {
    this.isBusy = true;
    await this.getEvent();
    await this.getCheckinReport();
    this.isBusy = false;
  },
  watch: {
    async currentPage(val, oldVal) {
      if (oldVal != val) {
        this.currentPage = val;
        this.isBusy = true;
        await this.getCheckinReport();
        this.isBusy = false;
      }
    },
  },
  methods: {
    async getEvent() {
      const result = await Service.Event.get(this.$route.query.e);
      this.event = result.data.event;
    },
    async getCheckinReport() {
      const queryObject = {
        event_id: this.event.event_id,
        currentPage: this.currentPage,
        perPage: this.perPage,
      };
      if (this.selectedReport != "all") {
        queryObject.checkin_date = this.selectedReport;
      }
      const queryString = Object.keys(queryObject)
        .map((key) => key + "=" + queryObject[key])
        .join("&");

        console.log(queryString)
      const result = await Service.Report.checkinReportGroup(queryString);
      if (result.data.day_list) {
        this.reportOptions = [
          { type: "pre", label: "All Days", value: "all" },
          ...result.data.day_list.map((item) => {
            return {
              type: item.type,
              label: item.label,
              value: item.value,
            };
          }),
        ];
      }

      this.checkinReportGroup = result.data.rows;
      this.totalRows = result.data.total;
      this.from = result.data.from;
      this.to = result.data.to;
      this.perPage = parseInt(result.data.per_page);
    },
    async getCheckinLog(ticket) {
      const queryObject = {
        event_id: this.event.event_id,
        currentPage: 1,
        perPage: 50,
        ticket: ticket,
      };
      const queryString = Object.keys(queryObject)
        .map((key) => key + "=" + queryObject[key])
        .join("&");

      const result = await Service.Ticket.history(queryString);
      if (!result.data.rows || result.data.rows.length == 0) {
        this.checkinLog = [];
        return;
      }

      this.checkinLog = result.data.rows.map((e) => ({
        ...e,
        name: e.firstName + " " + e.lastName,
      }));
    },
    async reportChangeHandler() {
      this.currentPage = 1;
      this.isBusy = true;
      await this.getCheckinReport();
      this.isBusy = false;
    },
    async viewLogHandler(row) {
      this.checkinLog = [];
      this.checkinLogPopup = true;
      await this.getCheckinLog(row.ticket);
    },
    async exportHandler() {
      const queryObject = {
        event_id: this.event.event_id,
        currentPage: 1,
        perPage: 1000,
      };

      if (this.selectedReport != "all") {
        queryObject.checkin_date = this.selectedReport;
      }

      const queryString = Object.keys(queryObject)
        .map((key) => key + "=" + queryObject[key])
        .join("&");

      const result = await Service.Report.checkinReportGroup(queryString);
      if (!result.data.rows || result.data.rows.length === 0) return;
      const resultMapped = result.data.rows.map((e)=> {
        return {
          Name: e.name,
          Ticket: e.ticket,
          Role: e.role,
          Type: e.type,
          Count: e.count,
          At: e.at,
        }
      })
      const dataWS = XLSX.utils.json_to_sheet(resultMapped);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "check-in-attendee.xlsx");
      this.$vs.loading.close();
    }
  },
};
</script>
